module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/promotion/forgot-password/forgot-password.component.css
// module id = ./src/app/promotion/forgot-password/forgot-password.component.css
// module chunks = main